// extracted by mini-css-extract-plugin
module.exports = {"Container":"Post_Container__3bIac","Post":"Post_Post__esa_S"};